/**
 * A stored picture key joined onto the address pictures are served from.
 *
 * ⚠ THE SAME FOLDER TWICE. The stages publish `s3_file_url` ending in `/marketing_page_images/` while the key stored for an upload also
 * starts with `marketing_page_images/`, so a plain `base + key` drew `…/marketing_page_images/marketing_page_images/x.jpg` - a broken
 * picture on every uploaded cover and photo. A folder the base already ends with is not added a second time. Only whole path segments
 * are compared, tail of the base against head of the key.
 *
 * ⚠ TWO COPIES, KEPT EQUAL BY THEIR SPECS: the server uses the same rule in partner-backend `app/utils/joinPublicUrl.js`. Change one and
 * change the other in the same piece of work, or pictures break on one side only.
 */
export const joinPublicUrl = (base: string | null | undefined, key: string): string => {
    const root = String(base || '').replace(/\/+$/, '');
    const path = String(key || '').replace(/^\/+/, '');
    if (!root) {
        return path;
    }
    const origin = /^[a-z][a-z0-9+.-]*:\/\/[^/]+/i.exec(root)?.[0] ?? '';
    const baseSegments = root.slice(origin.length).split('/').filter(Boolean);
    const keySegments = path.split('/');
    for (let overlap = Math.min(baseSegments.length, keySegments.length - 1); overlap > 0; overlap -= 1) {
        const tail = baseSegments.slice(-overlap);
        if (tail.every((segment, index) => segment === keySegments[index])) {
            return `${root}/${keySegments.slice(overlap).join('/')}`;
        }
    }
    return `${root}/${path}`;
};
